module.exports = __webpack_public_path__ + "img/wtc.5d9511da.jpg";